import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonBaseComponent } from './button-base.component';


@Component({
	selector: 'app-core-button-generic-icon',
	templateUrl: './button-icon-base.component.html'
})
export class CoreButtonGenericIconComponent extends ButtonBaseComponent {
	@Input()
	public iconClass = 'fa-question';
	@Input()
	public titleTranslateKey = 'button.generic';
	@Input()
	public color: string;
	@Input()
	public disabled: boolean = false;

	@Input()
	public type = 'button';


	@Input()
	public hintTranslateKey: string;


	@Output()
	action: EventEmitter<ButtonBaseComponent> = new EventEmitter<ButtonBaseComponent>();
}